import * as Actions from '../../../redux/actions'

import { Element, Link } from 'react-scroll'

import About from './About'
import Experiences from './Experiences'
import Neighborhood from './Neighborhood'
import Breadcrumb from './Breadcrumb'
import Contact from './Contact'
import EstablishmentBasicInfo from './EstablishmentBasicInfo'
import ReviewContainer from "./ReviewContainer"
//import EstablishmentReviews from '../Common/Establishment/EstablishmentReviews'
import { Menu } from 'semantic-ui-react'
import React from 'react'
import TopBarSlider from './TopBarSlider'
import { connect } from 'react-redux'
import { HeaderMobile } from '../Header/HeaderMobile'

const DestinationFeature_ = ({ props, sliderImages, setEstablishmentId, is_mobile, establishment, logo_height, app_menu_height, lang, fetchEstablishment, fetchPhotoGalleryEstablishment, fetchExperiencesEstablishment, fetchNeighborhoodEstablishment, fetchGoogleAndYelpReviewsEstablishment }) => {
    const [menu, setMenu] = React.useState("about")
    /* fetch destination */
    React.useEffect(() => {
        if (props.match.params.establishmentID !== undefined &&
            props.match.params.establishmentID !== null &&
            props.match.params.establishmentID !== "") {
            fetchEstablishment(props.match.params.establishmentID, lang)
            fetchPhotoGalleryEstablishment(props.match.params.establishmentID, lang, 1)
            fetchExperiencesEstablishment(props.match.params.establishmentID, lang)
            fetchNeighborhoodEstablishment(props.match.params.establishmentID, lang)
            fetchGoogleAndYelpReviewsEstablishment(props.match.params.establishmentID, lang)
            setEstablishmentId(props.match.params.establishmentID)
        }
    }, [props.match.params.establishmentID])
    const breadcrumb = establishment.breadcrumb
    const generalInfo = establishment.generalInfo
    let padding_l = 15
    let padding_r = 15

    if (!isNaN(is_mobile)) {
        padding_l = is_mobile ? "1" : "15"
        padding_r = is_mobile ? "1" : "15"
    }
    const headerHeight = (-Math.ceil(-app_menu_height / 2))
    const menuOffset = -headerHeight - 90
    const experiencesExisted = establishment && establishment.experiences && establishment.experiences.length > 0
    const neighborhoodExisted = establishment && establishment.neighborhood

    return (
        <React.Fragment>

            <div style={{ position: "relative", paddingBottom: 200 }} >
                {!is_mobile ? null : <HeaderMobile bg_color={"var(--frameBlack)"} text_color={"var(--mainWhite)"} />}

                {sliderImages !== undefined && sliderImages.length > 0 && <TopBarSlider />}

                {breadcrumb !== undefined && breadcrumb.length > 0 && <Breadcrumb />}

                <div className="establishmentContainer">
                    <div style={{
                        position: "sticky", zIndex: "3",
                        top: is_mobile ? logo_height : headerHeight,
                        paddingLeft: padding_l + "%",
                        paddingRight: padding_r + "%",
                    }} >
                        <Menu className="establishmentMenu" pointing secondary style={{ position: "relative", backgroundColor: "#FFFFFF", borderBottom: "10px solid #F8F8F8", paddingTop: "60px", }}>
                            {
                                <Link to="about" spy={true} smooth={true} offset={menuOffset} duration={1000} style={{
                                    font: "18px/18px Futura Md BT",
                                    letterSpacing: "0",
                                    backgroundColor: "initial",
                                    fontWeight: "bold",
                                    opacity: "1",
                                    textAlign: "center",
                                    height: "40px",
                                    padding: "0px 20px",
                                    width: "200px",
                                    position: "absolute",
                                    bottom: "-10px",
                                    color: menu === "about" ? "var(--mainGreen)" : "#191919",
                                    cursor: menu === "about" ? "" : "pointer",
                                    borderBottom: menu === "about" ? "10px solid var(--mainGreen)" : "10px solid #F8F8F8",
                                }} ><p style={{
                                    verticalAlign: "middle"
                                }} onClick={() => setMenu("about")}
                                > About</p></Link>
                            }
                            {
                                <Link to="reviews" spy={true} smooth={true} offset={menuOffset} duration={1000} style={{
                                    font: "18px/18px Futura Md BT",
                                    letterSpacing: "0",
                                    backgroundColor: "initial",
                                    fontWeight: "bold",
                                    opacity: "1",
                                    textAlign: "center",
                                    height: "40px",
                                    width: "200px",
                                    position: "absolute",
                                    bottom: "-10px",
                                    left: "200px",
                                    padding: "0px 20px",
                                    color: menu === "reviews" ? "var(--mainGreen)" : "#191919",
                                    cursor: menu === "reviews" ? "" : "pointer",
                                    borderBottom: menu === "reviews" ? "10px solid var(--mainGreen)" : "10px solid #F8F8F8",
                                }} ><p style={{
                                    verticalAlign: "middle"
                                }} onClick={() => setMenu("reviews")}>Reviews</p></Link>
                            }
                            {
                                experiencesExisted && <Link to="experiences" spy={true} smooth={true} offset={menuOffset} duration={1000} style={{
                                    font: "18px/18px Futura Md BT",
                                    letterSpacing: "0",
                                    backgroundColor: "initial",
                                    fontWeight: "bold",
                                    opacity: "1",
                                    textAlign: "center",
                                    height: "40px",
                                    width: "200px",
                                    position: "absolute",
                                    bottom: "-10px",
                                    left: "400px",
                                    padding: "0px 20px",
                                    color: menu === "experiences" ? "var(--mainGreen)" : "#191919",
                                    cursor: menu === "experiences" ? "" : "pointer",
                                    borderBottom: menu === "experiences" ? "10px solid var(--mainGreen)" : "10px solid #F8F8F8",
                                }} ><p style={{
                                    verticalAlign: "middle"
                                }} onClick={() => setMenu("experiences")}>Experiences</p></Link>
                            }
                            {
                                neighborhoodExisted && <Link to="neighborhood" spy={true} smooth={true} offset={menuOffset} duration={1000} style={{
                                    font: "18px/18px Futura Md BT",
                                    letterSpacing: "0",
                                    backgroundColor: "initial",
                                    fontWeight: "bold",
                                    opacity: "1",
                                    textAlign: "center",
                                    height: "40px",
                                    width: "200px",
                                    position: "absolute",
                                    bottom: "-10px",
                                    left: experiencesExisted ? "600px" : "400px",
                                    padding: "0px 20px",
                                    color: menu === "neighborhood" ? "var(--mainGreen)" : "#191919",
                                    cursor: menu === "neighborhood" ? "" : "pointer",
                                    borderBottom: menu === "neighborhood" ? "10px solid var(--mainGreen)" : "10px solid #F8F8F8",
                                }} ><p style={{
                                    verticalAlign: "middle"
                                }} onClick={() => setMenu("neighborhood")}>Neighborhood</p></Link>
                            }
                            {
                                <Link to="contact" spy={true} smooth={true} offset={menuOffset} duration={1000} style={{
                                    font: "18px/18px Futura Md BT",
                                    letterSpacing: "0",
                                    backgroundColor: "initial",
                                    fontWeight: "bold",
                                    opacity: "1",
                                    textAlign: "center",
                                    width: "200px",
                                    height: "40px",

                                    position: "absolute",
                                    bottom: "-10px",
                                    left: (!experiencesExisted && !neighborhoodExisted) ? "400px" : ((experiencesExisted && !neighborhoodExisted) || (!experiencesExisted && neighborhoodExisted)) ? "600px" : "800px",
                                    padding: "0px 20px",
                                    color: menu === "contact" ? "var(--mainGreen)" : "#191919",
                                    cursor: menu === "contact" ? "" : "pointer",
                                    borderBottom: menu === "contact" ? "10px solid var(--mainGreen)" : "10px solid #F8F8F8",
                                }} ><p style={{
                                    verticalAlign: "middle"
                                }} onClick={() => setMenu("contact")}>Contact</p></Link>
                            }
                        </Menu>
                    </div>
                    {generalInfo !== undefined && generalInfo !== null && <div style={{
                        paddingLeft: padding_l + "%",
                        paddingRight: padding_r + "%",
                        marginTop: "20px"
                    }}>

                        <EstablishmentBasicInfo />
                        <hr className="line_separator_w margin_top_50 margin_bottom_50" />

                    </div>}
                    {generalInfo !== undefined && generalInfo !== null && generalInfo.about !== null && generalInfo.about !== "" && <div style={{
                        paddingLeft: padding_l + "%",
                        paddingRight: padding_r + "%",
                    }}>
                        <Element name="about" className="element">
                            <About />
                            <hr className="line_separator_w margin_top_50 margin_bottom_50" />
                        </Element>
                    </div>}

                    {<div style={{
                        paddingLeft: padding_l + "%",
                        paddingRight: padding_r + "%",
                    }}>
                        <Element name="reviews" className="element">
                            <ReviewContainer />
                            <hr className="line_separator_w margin_top_50 margin_bottom_50" />
                        </Element>
                    </div>}

                    {experiencesExisted && <div style={{
                        paddingLeft: padding_l + "%",
                        paddingRight: padding_r + "%",
                    }}>
                        <Element name="experiences" className="element">
                            <Experiences />
                            <hr className="line_separator_w margin_top_50 margin_bottom_50" />
                        </Element>
                    </div>}

                    {neighborhoodExisted && <div style={{
                        paddingLeft: padding_l + "%",
                        paddingRight: padding_r + "%",
                    }}>
                        <Element name="neighborhood" className="element">
                            <Neighborhood />
                            <hr className="line_separator_w margin_top_50 margin_bottom_50" />
                        </Element>
                    </div>}

                    {generalInfo !== undefined && generalInfo !== null && generalInfo.address !== undefined && generalInfo.address !== null && <div style={{
                        paddingLeft: padding_l + "%",
                        paddingRight: padding_r + "%",
                    }}>
                        <Element name="contact" className="element">
                            <Contact />
                        </Element>
                    </div>}
                </div>
            </div>

        </React.Fragment >
    )
}


const mapStateToProps = state => {
    return {
        logo_height: state.Setting.appMenu.logo.height,
        sliderImages: state.Destination.establishment.sliderImages,
        lang: state.Setting.lang,

        is_mobile: state.Setting.is_mobile,
        app_menu_height: state.Setting.appMenu.app_menu_height,
        screenSize: state.Setting.htmlBody.bodyClientWidth,

        establishment: state.Destination.establishment,
    }
}

const mapDispatchToProps = {
    fetchEstablishment: Actions.fetchEstablishment,
    fetchPhotoGalleryEstablishment: Actions.fetchPhotoGalleryEstablishment,
    fetchExperiencesEstablishment: Actions.fetchExperiencesEstablishment,
    fetchNeighborhoodEstablishment: Actions.fetchNeighborhoodEstablishment,
    fetchGoogleAndYelpReviewsEstablishment: Actions.fetchGoogleAndYelpReviewsEstablishment,


    setEstablishmentId: Actions.setEstablishmentId,
}

const DestinationFeature = connect(mapStateToProps, mapDispatchToProps)(DestinationFeature_)
export default DestinationFeature
